import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {ComponentBase} from '@drl/core/component-base';
import { AddNewRecordComponent } from './add-record-modal/add-record.component';
import { NbDialogService } from '@nebular/theme';
import { BulkUploadComponent } from '@drl/shared/components/header/bulk-upload/bulk-upload.component';
import { Appointment } from '@drl/shared/models';
import { PatientDataFacadeService } from './patient-data-facade.service';
import { AppointmentBulk } from './appointment-bulk.model';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { SystemStoreFacadeService } from '@drl/core/store/system-store-facade.service';
import { map } from 'lodash-es';
import { CsvType, csvTypeMap } from '@drl/shared/utility/csv-type.utility';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { AddNewPrescriptionRecordComponent } from './add-prescription-record-modal/add-prescription-record-modal';
import { Prescriptions } from '../patients/shared/models';
import { PrescriptionBulk } from './prescription-bulk.model';


@Component({
  selector: 'app-data-upload',
  templateUrl: './data-upload.component.html',
  styleUrls: [],
})
export class DataUploadComponent extends ComponentBase {
  constructor(
    private readonly dialogService: NbDialogService,
    private readonly patientDataService: PatientDataFacadeService,
    private readonly toastrService: ToastrService,
    private readonly confirmationService: ConfirmationService,
    private readonly systemStoreFacade: SystemStoreFacadeService,
    protected readonly translateSvc: TranslateService,
    ) {
      super();
    }
    dropdownOptions = [
      {label: 'Appointments', value: 'Appointments'},
      {label: 'Patients', value: 'Patients'},
      {label: 'Prescriptions', value: 'Prescriptions'},
      {label: 'Therapy Plans', value: 'Therapy Plans'}
    ];
    locale: string;
    logo = '/assets/notes.png';
    apptList: Appointment[] = [];
    prescriptionsList: Prescriptions[] = [];
    selectedDropDownValue:string = CsvType.Prescription;
    btnEnabledOption2: string = CsvType.Prescription;
    btnEnabledOption = CsvType.Appointment
    loading: boolean;
    dataUploadPath = 'main/data-upload';
  ngOnInit() {
    this.systemStoreFacade.getLocale().subscribe(locale => {
      this.locale = locale;
      this.dropdownOptions = map(
        csvTypeMap(this.translateSvc, this.locale),
        (cat, key) => {
          return {
            label: cat.name,
            value: cat.key,
          };
        },
      );
    });
    this.dialogService.open(AddNewPrescriptionRecordComponent).onClose.subscribe(res => {});
  }



  addNewRecord(flag:boolean, appt?: Appointment, prescription?: Prescriptions,) {
    if(this.selectedDropDownValue === CsvType.Appointment){
      if(!flag && this.apptList.length === 10){
        this.toastrService.error(this.translateSvc.instant('max10RecordMsg'),this.translateSvc.instant('errorLbl'));
        return;
      }
      let context = {};
      if(flag){
      context = {
        appt,
      };
      }

      this._subscriptions.push(
        this.dialogService
          .open(AddNewRecordComponent, {
            context
          })
          .onClose.subscribe(res => {
            if (res && !res.error) {
              const idx = this.apptList.findIndex(appt => { return appt.uniqId === res.appt.uniqId});
              if(idx !== -1){
                this.apptList[idx] = res.appt;
              }
              else{
                this.apptList.push(res.appt);
              }
            }
          }),
      );
    } else if(this.selectedDropDownValue === CsvType.Prescription){
      if(!flag && this.prescriptionsList.length === 10){
        this.toastrService.error(this.translateSvc.instant('max10RecordMsg'),this.translateSvc.instant('errorLbl'));
        return;
      }
      let context = {};
      if(flag){
        context = {
          prescription,
        };
      }
      this._subscriptions.push(
        this.dialogService
          .open(AddNewPrescriptionRecordComponent, {
            context
          })
          .onClose.subscribe(res => {
            if (res && !res.error) {
              const idx = this.prescriptionsList.findIndex(prescription => { return prescription.uniqId === res.prescription.uniqId});
              if(idx !== -1){
                this.prescriptionsList[idx] = res.prescription;
              }
              else{
                this.prescriptionsList.push(res.prescription);
              }
            }
          }),
      );
    }
  }
  uploadRecords(){
    this.loading = true;
    const appointmentBulk = new AppointmentBulk();
    appointmentBulk.appointments = [];
    for(let appt of this.apptList){
      delete appt.apptTime;
      if(appt.apptDateTimeString){
        appt.apptDate = moment(appt.apptDateTimeString).toDate();
      }
      appointmentBulk.appointments.push({...appt});
    }
    this.patientDataService.createBulkAppointment(appointmentBulk).subscribe(()=>{
      this.toastrService.success(this.translateSvc.instant('recordUploadSuccess'), this.translateSvc.instant('successLbl'));
      this.loading = false;
      setTimeout(()=>{
        window.location.reload();
      }, 1000)
    })
  }

  uploadRecordsPrescription(){
    this.loading = true;
    const prescriptionBulk = new PrescriptionBulk();
    prescriptionBulk.prescriptions = [];
    for(let presc of this.prescriptionsList){
      if(presc.prescDateTimeString){
        presc.prescriptionDate = moment(presc.prescDateTimeString).toDate();
      }
      prescriptionBulk.prescriptions.push({...presc});
    }
    this.patientDataService.createBulkPrescription(prescriptionBulk).subscribe(()=>{
      this.toastrService.success(this.translateSvc.instant('recordUploadSuccess'), this.translateSvc.instant('successLbl'));
      this.loading = false;
      setTimeout(()=>{
        window.location.reload();
      }, 1000)
    })
  }

  uploadConfirm(){
    if(this.selectedDropDownValue === CsvType.Appointment && this.apptList.length > 0){
      this.confirmationService.confirm({
        key: 'updateConfirm',
        message: this.translateSvc.instant('bulkUploadConfirmationText'),
        accept: () => {
          this.uploadRecords();
        },
      });
    } else if(this.selectedDropDownValue === CsvType.Prescription && this.prescriptionsList.length > 0){
      this.confirmationService.confirm({
        key: 'uploadPrescriptionConfirm',
        message: 'Are you sure you want to upload the prescription(s)?',
        accept: () => {
          this.uploadRecordsPrescription();
        },
      });
    }
  }

  ondropdownValueChange(){
    this.apptList = [];
  }

  openUploadCsvDialog() {
    this._subscriptions.push(
      this.dialogService.open(BulkUploadComponent).onClose.subscribe(res => {}),
      );
  }
  deleteConfirm(idx: number) {
    this.confirmationService.confirm({
        key: 'deleteConfirm',
        message: 'Are you sure you want to delete the prescription?',
        accept: () => {
          this.removePrescription(idx);
        },
      });
  }

  removePrescription(index: number) {
    this.prescriptionsList.splice(index, 1);
  }
}
